import { IsiControlEvents } from "./IsiControlEvents";

//export module IsiFW {
//export namespace IsiFW {
export class IsiControl {

    _events: IsiControlEvents;
    _element: HTMLElement;
    jQueryElement: JQuery;

    /**
 * Nom de la classe est notamment ajouter aux classes css de l'element root du composant
 */
    public static clsName = "IsiControl"

    constructor(element) {
        this._element = element;
        this._events = new IsiControlEvents();
      
    }

    initialize() {

    }

    dispose() {

    }

    get_parent(): IsiControl {
        return null;
    }

    get_element() {
        return this._element;
    }

    getJQueryElement() {
        if (!this.jQueryElement || this.jQueryElement.length === 0) {
            this.jQueryElement = jQuery(this.get_element());
        }
        return this.jQueryElement;
    }

    get_events() {
        return this._events;
    }

    get_id() {
        if (!this.get_element()) throw "Aucun élément";
        return this.get_element().getAttribute("id");
        //return this.getJQueryElement().attr("id");
    }

    


}


//}
